import { Theme } from '@radix-ui/themes'
import type { ReactNode } from 'react'

interface ThemeProviderProps {
  children: ReactNode
  appearance?: 'light' | 'dark'
  accentColor?: 'gray' | 'blue' | 'green' | 'red'
  grayColor?: 'gray' | 'auto' | 'mauve' | 'slate' | 'sage' | 'olive' | 'sand'
  radius?: 'none' | 'small' | 'medium' | 'large' | 'full'
  scaling?: '90%' | '95%' | '100%' | '105%' | '110%'
  panelBackground?: 'solid' | 'translucent'
}

export const ThemeProvider = ({
  children,
  appearance = 'light',
  accentColor = 'blue',
  grayColor = 'gray',
  radius = 'medium',
  scaling = '100%',
  panelBackground = 'translucent'
}: ThemeProviderProps) => {
  return (
    <Theme
      appearance={appearance}
      accentColor={accentColor}
      grayColor={grayColor}
      radius={radius}
      scaling={scaling}
      panelBackground={panelBackground}
    >
      {children}
    </Theme>
  )
} 